const translations = {
  "en": {
    "Card": "Card",
    "Pay with %{var0}": "Pay with %{var0}",
    "Pay with Airwallex": "Pay with Airwallex",
    "Pay with card": "Pay with card",
    "Pay with PayPal": "Pay with PayPal"
  },
  "zh-tw": {
    "Card": "卡片",
    "Pay with %{var0}": "使用 %{var0} 付款",
    "Pay with Airwallex": "使用 Airwallex 付款",
    "Pay with card": "使用卡片付款",
    "Pay with PayPal": "使用 PayPal 付款"
  }
};

export default translations;
